import React from 'react';
import classNames from 'classnames';
import styles from './css/index.module.scss';
import BackButton from '../BackButton';
import GlassSettings from '../GlassSettings';
import FrameSettings from '../FrameSettings';
import Button from '../../../../ui-kit/Button';
import useSoundproofing from '../../../../hooks/useSoundproofing';
import useTranslations from '../../../../hooks/useTranslations';
import { DICTIONARY } from '../../../../translations/dictionary';
import { SOUNDPROOFING_LAYER_TYPES } from '../../../../constants/soundproofing';
import SoundproofingServices from '../../../../services/SoundproofingServices';

function LayerSettings({ isBottomSheet }) {
  const { t } = useTranslations();
  const {
    selectedLayer, deselectLayer, updateLayerParams, clearLayerParams,
  } = useSoundproofing();

  if (!selectedLayer) return null;

  const SettingsComponent = selectedLayer.type === SOUNDPROOFING_LAYER_TYPES.glass ? GlassSettings : FrameSettings;

  return (
    <div className={classNames(styles.settings, { [styles.settingsBottomSheet]: isBottomSheet })}>
      <BackButton onClick={deselectLayer} />

      <div className={classNames(styles.content, 'blueVerticalScroll')}>
        <SettingsComponent
          key={selectedLayer.id}
          layer={selectedLayer}
          updateLayerParams={updateLayerParams}
        />
      </div>

      <div className={styles.button}>
        <Button
          width="100%"
          text={t(DICTIONARY.soundproofingPage.clearFilters)}
          isDisabled={!SoundproofingServices.isLayerFilled(selectedLayer)}
          onClick={() => clearLayerParams(selectedLayer.id)}
        />
      </div>
    </div>
  );
}

export default LayerSettings;
